module.exports = __webpack_public_path__ + "img/pocket flap width.28a95995.png";